"use client";
import PropTypes from "prop-types";

import styles from "./styles.module.css";

const GptAd = ({ elementId, elementClass, style }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        height: "100%",
        ...style,
      }}
    >
      <div className={styles.wrapper}>
        <div style={{ display: "none" }} className={elementClass} id={elementId} />
      </div>
    </div>
  );
};

GptAd.propTypes = {
  elementId: PropTypes.any,
  style: PropTypes.object,
  closable: PropTypes.bool,
  elementClass: PropTypes.any,
};

export default GptAd;
